import { Directive, ElementRef, Renderer2, OnInit, Output, EventEmitter, ViewContainerRef, inject } from '@angular/core';
import { CaptchaComponent } from '../components/captcha/captcha.component';

@Directive({
  selector: '[appUpdateCaptcha]',
  exportAs: 'appUpdateCaptcha'
})
export class UpdateCaptchaDirective implements OnInit {

  @Output() captchaRefreshed = new EventEmitter<any>();

  private renderer = inject(Renderer2);
  private el = inject(ElementRef);
  private vcr = inject(ViewContainerRef);

  private captchaRef: any;

  ngOnInit(): void {
      this.renderer.setAttribute(
    this.el.nativeElement,
    'placeholder',
    'Enter Captcha *'
  );
    const parent = this.renderer.parentNode(this.el.nativeElement);

    const wrapper = this.renderer.createElement('div');
    this.renderer.addClass(wrapper, 'd-flex');
    this.renderer.addClass(wrapper, 'align-items-center');

    // create wrapper BEFORE dynamic component
    this.renderer.insertBefore(parent, wrapper, this.el.nativeElement);

    // move input inside wrapper
    this.renderer.appendChild(wrapper, this.el.nativeElement);

    // ---- FIX: create dynamic component inside wrapper ----
    const compRef = this.vcr.createComponent(CaptchaComponent);
    wrapper.appendChild(compRef.location.nativeElement);

    this.captchaRef = compRef;

    // event emit
    this.captchaRef.instance.captchaRefreshed.subscribe((val: any) =>
      this.captchaRefreshed.emit(val)
    );
  }

  refreshCaptcha() {
    if (this.captchaRef?.instance?.refreshCaptcha) {
      const val = this.captchaRef.instance.refreshCaptcha();
      this.captchaRefreshed.emit(val);
    }
  }
}
